Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _airbnbI18n = require('airbnb-i18n');

var _airbnbI18n2 = _interopRequireDefault(_airbnbI18n);

var _airbnbEnv = require('airbnb-env');

var _logging_malformed_event_v = require('airbnb-jitney-schemas/logging_malformed_event_v1');

var _logging_universal_component_action_v = require('airbnb-jitney-schemas/logging_universal_component_action_v2');

var _logging_universal_component_impression_v = require('airbnb-jitney-schemas/logging_universal_component_impression_v2');

var _logging_universal_page_impression_v = require('airbnb-jitney-schemas/logging_universal_page_impression_v1');

var _logging_performance_airbnb_web_interactive_v = require('airbnb-jitney-schemas/logging_performance_airbnb_web_interactive_v1');

var _logging_performance_native_measurement_v = require('airbnb-jitney-schemas/logging_performance_native_measurement_v2');

var _amplifyStore = require('amplify-store');

var _amplifyStore2 = _interopRequireDefault(_amplifyStore);

var _validatePropTypes = require('./jitney/validatePropTypes');

var _validatePropTypes2 = _interopRequireDefault(_validatePropTypes);

var _airEventToJitneyEvent = require('./jitney/airEventToJitneyEvent');

var _airEventToJitneyEvent2 = _interopRequireDefault(_airEventToJitneyEvent);

var _getAirdogKeyName = require('./getAirdogKeyName');

var _getAirdogKeyName2 = _interopRequireDefault(_getAirdogKeyName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VERSION = '0.2';
var QUEUE_KEY = 'tracking_event_queue';

function debounce(func) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    global.cancelIdleCallback(timeout);
    timeout = global.requestIdleCallback(function () {
      timeout = null;
      func.apply(undefined, args);
    });
  };
}

// Privately keep track of the client's URI at the time that
// `logEvent` was last called.
var previousPageURI = null;

var EventLogger = function () {
  function EventLogger() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventLogger);

    this.logContext = {};
    if (typeof options.request !== 'function') {
      throw new Error('[tracking-js] EventLogger requires a `request` option to be passed in that is a function');
    }
    this.request = options.request;
    this.setupTrackingDebounce();
    this.debounceLogEvents = !!options.debounceLogEvents;
    this.pageURIChangeCallbacks = [];
  }

  _createClass(EventLogger, [{
    key: 'setupTrackingDebounce',
    value: function () {
      function setupTrackingDebounce() {
        var _this = this;

        var debouncedArgs = [];

        var debounceSendTrackingRequest = debounce(function (args) {
          var requestData = args.map(function (a) {
            return a.data;
          });
          var callbacks = args.map(function (a) {
            return a.callback;
          });
          // clear out immediately to avoid race conditions
          debouncedArgs = [];
          _this.sendTrackingRequest(requestData, function (success, error) {
            // loop through callbacks per request and respond
            callbacks.filter(Boolean).forEach(function (callback) {
              return callback(success, error);
            });
          });
        });

        this.sendTrackingRequestDebounced = function (data, callback) {
          if (callback && typeof callback !== 'function') {
            throw new Error('Callback provided was not of type function');
          }

          debouncedArgs = [].concat(_toConsumableArray(debouncedArgs), [{ data: data, callback: callback }]);
          debounceSendTrackingRequest(debouncedArgs);
        };
      }

      return setupTrackingDebounce;
    }()

    /**
     * clearContext() clears the existing context
     */

  }, {
    key: 'clearContext',
    value: function () {
      function clearContext() {
        this.logContext = {};
      }

      return clearContext;
    }()

    /**
     * addContext() adds data to be sent with every subsequent call to logEvent()
     * This merges the passed in value with the existing context.
     *
     * @param {Object} context
     */

  }, {
    key: 'addContext',
    value: function () {
      function addContext(context) {
        Object.assign(this.logContext, context);
      }

      return addContext;
    }()

    /**
     * addDefaultContext() adds a basic set of context we use across many rails apps.
     */

  }, {
    key: 'addDefaultContext',
    value: function () {
      function addDefaultContext() {
        var cookies = this.getCookies();

        this.updateDynamicContext();

        this.maybeAddCookie(cookies, 'affiliate');
        this.maybeAddCookie(cookies, 'campaign');
        this.maybeAddCookie(cookies, 'bev');
        this.maybeAddCookie(cookies, 'bev', 'visitor_id');

        var locale = _airbnbI18n2['default'].locale();
        if (locale) {
          this.addContext({
            locale: locale,
            language: locale.split('-')[0]
          });
        }
      }

      return addDefaultContext;
    }()
  }, {
    key: 'onPageURIChange',
    value: function () {
      function onPageURIChange(callback) {
        var _this2 = this;

        this.pageURIChangeCallbacks.push(callback);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }
            isSubscribed = false;

            var index = _this2.pageURIChangeCallbacks.indexOf(callback);
            _this2.pageURIChangeCallbacks.splice(index, 1);
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return onPageURIChange;
    }()
  }, {
    key: 'updateDynamicContext',
    value: function () {
      function updateDynamicContext() {
        // Since dynamic context is read from the global document object,
        // we only want this method to run if there *is* a document.
        if (typeof document === 'undefined') return;

        // Separately, if the document doesn't have a location, there is
        // little point to running this method.
        if (!document.location) return;

        // If the page_uri currently stored in context does not match
        // the current location pathname, the page's URL has changed since
        // the last call to `logEvent`. We then update our private reference
        // to the previous page's URI and use this as the referrer for
        // subsequently logged events.
        var didPageURIChange = false;
        if (this.logContext.page_uri !== document.location.pathname) {
          previousPageURI = this.logContext.page_uri;
          didPageURIChange = previousPageURI != null;
        }

        // Update the context that comes from the document, which is
        // liable to change between initialization and subsequent
        // calls to logEvent.
        this.addContext({
          page_uri: document.location.pathname,
          page_referrer: previousPageURI || document.referrer
        });

        if (didPageURIChange) {
          this.pageURIChangeCallbacks.forEach(function (callback) {
            return callback();
          });
        }
      }

      return updateDynamicContext;
    }()

    /**
     * logEvent() logs an event to Airbnb's logging system
     *
     * @param {Object} options
     * @param {string} options.event_name - required
     * @param {Object} options.event_data - user defined optional object which is merged with context
     * @param {function} options.callback - function to be called when logging is complete
     * @param {boolean} [options.queue=false] - if queue is true, the log will be queued
     */

  }, {
    key: 'logEvent',
    value: function () {
      function logEvent(options) {
        if (options.queue) {
          this.queueEvent(options);
          return;
        }

        this.validateOptions(options);
        var data = this.formatEventData(options);

        if (options.debounce !== false && (options.debounce || this.debounceLogEvents)) {
          this.sendTrackingRequestDebounced(data, options.callback);
        } else {
          this.sendTrackingRequest(data, options.callback);
        }
      }

      return logEvent;
    }()

    /**
     * queueEvent() queues up an event to be logged immediately upon next pageload.
     * This is useful for logging link clicks or form submissions that cause a
     * page navigation and would prevent the XHR from logEvent() from going through.
     *
     * @param {Object} options, same as logEvent()
     */

  }, {
    key: 'queueEvent',
    value: function () {
      function queueEvent(options) {
        this.validateOptions(options);

        var data = this.formatEventData(options);

        try {
          var queue = (0, _amplifyStore2['default'])(QUEUE_KEY) || [];
          queue.push(data);
          (0, _amplifyStore2['default'])(QUEUE_KEY, queue, { expires: 60000 });
        } catch (e) {
          (0, _airbnbEnv.warn)('Could not add event to queue: ' + String(e));
        }
      }

      return queueEvent;
    }()

    /**
     * logJitneyEvent() logs an event to Jitney pipeline
     *
     * @param {Object} options
     * @param {string} options.schema - required schema from airbnb/jitney-schemas
     * @param {Object} options.event_data - user defined object which is merged with context
     * @param {boolean} [options.queue=false] - if queue is true, the log will be queued
     */

  }, {
    key: 'logJitneyEvent',
    value: function () {
      function logJitneyEvent(_ref) {
        var _this3 = this;

        var schema = _ref.schema,
            jitneyEventData = _ref.event_data,
            queue = _ref.queue;

        if (!schema || !schema.defaultProps || !schema.defaultProps.schema) {
          throw new TypeError('Need to pass schema object from airbnb-jitney-schemas');
        }

        var schemaName = schema.defaultProps.schema;

        this.logEvent({
          event_name: 'jitney_' + String(schema.defaultProps.event_name),
          post_process: function () {
            function post_process(airEvent) {
              // TODO need to keep some common context fields like timestamp out of web
              var jitneyEvent = (0, _airEventToJitneyEvent2['default'])(airEvent, schema, jitneyEventData);

              jitneyEvent.schema = schemaName;
              jitneyEvent.event_data.context.user_agent = window.navigator.userAgent;

              var errors = void 0;

              /**
               * We need to special case these two event because they receive special treatment:
               *   1. They have a second validation step where their event_data.event_data field
               *   is validated by event_data.event_data_schema.
               *   2. We want to defer the stringification of their event_data.event_data until
               *   the event is emitted for performance optimization purposes.
               */
              if (schema.fullyQualifiedName === _logging_universal_component_action_v.UniversalComponentActionEvent.fullyQualifiedName || schema.fullyQualifiedName === _logging_universal_component_impression_v.UniversalComponentImpressionEvent.fullyQualifiedName || schema.fullyQualifiedName === _logging_universal_page_impression_v.UniversalPageImpressionEvent.fullyQualifiedName || schema.fullyQualifiedName === _logging_performance_airbnb_web_interactive_v.PerformanceAirbnbWebInteractiveEvent.fullyQualifiedName || schema.fullyQualifiedName === _logging_performance_native_measurement_v.NativeMeasurementEvent.fullyQualifiedName) {
                var _jitneyEvent$event_da = jitneyEvent.event_data,
                    event_data = _jitneyEvent$event_da.event_data,
                    event_data_schema = _jitneyEvent$event_da.event_data_schema,
                    rest = _objectWithoutProperties(_jitneyEvent$event_da, ['event_data', 'event_data_schema']);

                errors = (0, _validatePropTypes2['default'])(schema.propTypes, rest);

                var keysInEventData = event_data && Object.keys(event_data).length;

                /* eslint camelcase: 1 */
                if (keysInEventData > 0 && !event_data_schema) {
                  errors = ['Error: Cannot supply event_data to ' + String(schemaName) + ' without an event_data_schema'].concat(_toConsumableArray(errors));
                } else if (event_data_schema) {
                  errors = [].concat(_toConsumableArray((0, _validatePropTypes2['default'])(event_data_schema.propTypes, Object.assign({}, event_data_schema.defaultProps, event_data))), _toConsumableArray(errors));

                  if (errors.length === 0 && !queue) {
                    jitneyEvent.event_data.event_data = JSON.stringify(event_data);
                    jitneyEvent.event_data.event_data_schema = event_data_schema.fullyQualifiedName;
                  }
                } else if (keysInEventData === 0) {
                  jitneyEvent.event_data.event_data = undefined;
                }
              } else {
                errors = (0, _validatePropTypes2['default'])(schema.propTypes, jitneyEvent.event_data);
              }

              if (errors.length > 0) {
                if (typeof console !== 'undefined' && console.error) {
                  errors.forEach(function (error) {
                    return console.error(error);
                  }); // eslint-disable-line no-console
                }

                _this3.airdogBump('di.jitney.logging.invalid_event', 1, ['schema:' + String(schemaName)]);

                var malformedSchemaName = _logging_malformed_event_v.MalformedEvent.defaultProps.schema;
                return {
                  schema: malformedSchemaName,
                  event_data: {
                    schema: malformedSchemaName,
                    event_schema: schemaName,
                    event_json: JSON.stringify(jitneyEvent.event_data),
                    errors: errors.map(function (e) {
                      return e.toString();
                    }),
                    context: jitneyEvent.event_data && jitneyEvent.event_data.context || _this3.logContext
                  }
                };
              }
              return jitneyEvent;
            }

            return post_process;
          }(),
          callback: function () {
            function callback(isSuccessful, error) {
              if (!isSuccessful) {
                // This might fail too, but it's worth a shot.
                _this3.airdogBump('di.jitney.logging.tracking_error', 1, ['schema:' + String(schemaName)]);

                _this3.logEvent({
                  event_name: 'jitney_tracking_error',
                  event_data: {
                    schema_name: schemaName,
                    status: error.status,
                    responseText: error.responseText,
                    timeout: error.timeout
                  }
                });
              }
            }

            return callback;
          }(),
          queue: queue,
          debounce: false
        });
      }

      return logJitneyEvent;
    }()
  }, {
    key: 'queueJitneyEvent',
    value: function () {
      function queueJitneyEvent(_ref2) {
        var schema = _ref2.schema,
            event_data = _ref2.event_data;

        this.logJitneyEvent({
          schema: schema,
          event_data: event_data,
          queue: true
        });
      }

      return queueJitneyEvent;
    }()

    /**
     * flushEventQueue() logs any events that were queued up from the previous pageload.
     */

  }, {
    key: 'flushEventQueue',
    value: function () {
      function flushEventQueue() {
        var _this4 = this;

        try {
          var queue = (0, _amplifyStore2['default'])(QUEUE_KEY) || [];

          // IE8 only returns JSON strings. We have to manually parse.
          if (typeof queue === 'string') queue = JSON.parse(queue);

          if (queue.length > 0) {
            this.sendTrackingRequest(queue.map(function (data) {
              return Object.assign({}, data, {
                event_data: _this4.addContextToQueuedEvent(_this4.stringifyUniversalComponentEventData(data).event_data)
              });
            }));
          }

          // Clear out the queue.
          (0, _amplifyStore2['default'])(QUEUE_KEY, null);
        } catch (e) {
          (0, _airbnbEnv.warn)('Could not flush event queue: ' + String(e));
        }
      }

      return flushEventQueue;
    }()

    /**
     * validateOptions() throws an error if options are improperly formed.
     *
     * @param {Object} options
     * @throws {Error}
     */

  }, {
    key: 'validateOptions',
    value: function () {
      function validateOptions(options) {
        if (!options.event_name) {
          throw new Error('event_name is a required key for logEvent');
        }
      }

      return validateOptions;
    }()

    /**
     * formatEventData() formats the given options into the raw event data for the XHR,
     * adding request-specific properties and whatever else came from addContext().
     *
     * @param {Object} options
     * @return <Object> data
     */

  }, {
    key: 'formatEventData',
    value: function () {
      function formatEventData(options) {
        this.updateDynamicContext();

        var data = {
          event_name: options.event_name,
          event_data: Object.assign({}, this.logContext, {
            timestamp: Date.now()
          }, options.event_data),
          trackingjs_logging_version: VERSION
        };

        if (options.post_process) {
          return options.post_process(data);
        }
        return data;
      }

      return formatEventData;
    }()

    /**
     * stringifyUniversalComponentEventData() adds deferred formatting when the event is
     * emitted as a performance optimization. For large event_data objects, the stringification
     * can be expensive. Deferring it as long as possible is preferable.
     *
     * @param {Object} data
     */

  }, {
    key: 'stringifyUniversalComponentEventData',
    value: function () {
      function stringifyUniversalComponentEventData(data) {
        if (data.schema === 'com.airbnb.jitney.event.logging.Universal:UniversalComponentActionEvent:2.0.0' || data.schema === 'com.airbnb.jitney.event.logging.Universal:UniversalComponentImpressionEvent:2.0.0' || data.schema === 'com.airbnb.jitney.event.logging.Universal:UniversalPageImpressionEvent:1.0.0' || data.schema === 'com.airbnb.jitney.event.logging.Performance:PerformanceAirbnbWebInteractiveEvent:1.0.0' || data.schema === 'com.airbnb.jitney.event.logging.Performance:NativeMeasurementEvent:2.0.0') {
          if (data.event_data.event_data_schema) {
            return Object.assign({}, data, {
              event_data: Object.assign({}, data.event_data, {
                event_data: JSON.stringify(data.event_data.event_data),
                event_data_schema: data.event_data.event_data_schema.fullyQualifiedName || 'unknown'
              })
            });
          }
        }
        return data;
      }

      return stringifyUniversalComponentEventData;
    }()

    /**
     * addContextToQueuedEvent() adds additional context to event data so we know
     * if it has been queued.
     *
     * @param {Object} eventData
     */

  }, {
    key: 'addContextToQueuedEvent',
    value: function () {
      function addContextToQueuedEvent(eventData) {
        if (eventData.schema) {
          // Jitney events
          return Object.assign({}, eventData, {
            context: Object.assign({}, eventData.context, {
              web: Object.assign({}, eventData.context.web, {
                queued: true
              })
            })
          });
        }

        // airevents
        return Object.assign({}, eventData, {
          trackingjs_queued: true,
          trackingjs_queued_context: this.logContext
        });
      }

      return addContextToQueuedEvent;
    }()

    /**
     * sendTrackingRequest() actually sends the XHR for given event data.
     *
     * @param {Object} data
     */

  }, {
    key: 'sendTrackingRequest',
    value: function () {
      function sendTrackingRequest(data, callback) {
        var _this5 = this;

        this.request(data).then(function () {
          return callback && callback(true);
        })['catch'](function (error) {
          _this5.logEventFailed(data);
          if (callback) {
            callback(false, error);
          }
        });

        // log event data in the browser console for debugging/testing tracking setup
        if ((0, _airbnbEnv.isDev)()) {
          if ((0, _amplifyStore2['default'])('log-in-dev')) {
            (0, _airbnbEnv.log)('--- Tracking.logEvent ---');
            (0, _airbnbEnv.log)(data);
          }
        }
      }

      return sendTrackingRequest;
    }()

    /**
     * logEventFailed() Log to the console about a failed attempt to log an event
     *
     * @param {Object} data (see formatEventData for definition)
     */

  }, {
    key: 'logEventFailed',
    value: function () {
      function logEventFailed(data) {
        (0, _airbnbEnv.warn)('Failed to log event (event=' + String(data.event_name) + ')');
      }

      return logEventFailed;
    }()

    /**
     * Returns the document's cookies as an object of name/value pairs.
     * Assumes that cookie values are encoded with encodeURIComponent(),
     * but doesn't break if they aren't.
     * https://www.inkling.com/read/javascript-definitive-guide-david-flanagan-6th/chapter-20/parsing-the-document-cookies
     */

  }, {
    key: 'getCookies',
    value: function () {
      function getCookies() {
        var cookies = {};
        var all = document.cookie;

        if (all === '') {
          return cookies;
        }

        var list = all.split('; ');
        // TODO: turn into .reduce()
        for (var i = 0; i < list.length; i += 1) {
          var cookie = list[i];
          var p = cookie.indexOf('=');
          var name = cookie.slice(0, p);
          var value = cookie.slice(p + 1);

          try {
            value = decodeURIComponent(value);
          } catch (ex) {
            this.logEvent({
              event_name: 'cookie_decode_failed',
              event_data: {
                cookie: cookie
              }
            });
            value = '';
          }

          cookies[name] = value;
        }

        return cookies;
      }

      return getCookies;
    }()

    /**
     * maybeAddCookie() adds a cookie to the context if the value is not null
     *
     * @param {Object} cookies
     * @param {String} key
     */

  }, {
    key: 'maybeAddCookie',
    value: function () {
      function maybeAddCookie(cookies, key, override_context_key) {
        if (cookies[key] != null) {
          this.addContext(_defineProperty({}, override_context_key || key, cookies[key]));
        }
      }

      return maybeAddCookie;
    }()
  }, {
    key: 'airdogBump',
    value: function () {
      function airdogBump(key, count, tags, queue) {
        var payload = {
          event_name: 'airdog_bump',
          event_data: {
            datadog_key: key,
            queue: queue
          }
        };

        if (count) {
          payload.event_data.datadog_count = count;
        }

        if (tags) {
          if ((typeof tags === 'undefined' ? 'undefined' : _typeof(tags)) === 'object' && !Array.isArray(tags)) {
            payload.event_data.datadog_tags = Object.entries(tags).map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  tagKey = _ref4[0],
                  tagValue = _ref4[1];

              return String(tagKey) + ':' + String(tagValue);
            }).join(',');
          } else {
            payload.event_data.datadog_tags = tags;
          }
        }

        this.logEvent(payload);
      }

      return airdogBump;
    }()
  }, {
    key: 'logAirdogEvent',
    value: function () {
      function logAirdogEvent(data) {
        var eventData = data.event_data || {};

        this.logEvent(Object.assign({}, data, {
          event_data: Object.assign({}, eventData, {
            datadog_key: eventData.datadog_key || (0, _getAirdogKeyName2['default'])(data)
          })
        }));
      }

      return logAirdogEvent;
    }()
  }]);

  return EventLogger;
}();

exports['default'] = EventLogger;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/EventLogger.js
// module id = 471
// module chunks = 168707334958949